import React, { useEffect } from 'react';
import './Hero.css';

export default function Hero() {
  useEffect(() => {
    // Initialize FinisherHeader with vibrant config
    const initFinisher = () => {
      if (window.FinisherHeader) {
        try {
          new window.FinisherHeader({
            className: 'finisher-header',
            count: 35,
            size: {
              min: 5,
              max: 120,
              pulse: 0.1
            },
            speed: {
              x: {
                min: 0,
                max: 0.2
              },
              y: {
                min: 0,
                max: 0.4
              }
            },
            colors: {
              background: "#b580ff",
              particles: [
                "#ffe960",
                "#87ddfe",
                "#8481ff",
                "#fc7bfc",
                "#e2ffa5"
              ]
            },
            blending: "overlay",
            opacity: {
              center: 0,
              edge: 0.7
            },
            skew: -2,
            shapes: [
              "c"
            ]
          });
          console.log('FinisherHeader initialized for Hero');
        } catch (error) {
          console.error('Error initializing FinisherHeader:', error);
        }
      } else {
        // Retry if library not loaded yet
        setTimeout(initFinisher, 100);
      }
    };
    
    initFinisher();
  }, []);

  return (
    <div className="finisher-header">
      {/* Text content overlay */}
      <div className="hero-content">
        <div className="hero-text">
          <h2>Excellence in Education</h2>
          <p>Building Bright Futures for Every Child</p>
          <a href="#about" className="btn btn-light btn-lg">Learn More</a>
        </div>
      </div>
    </div>
  );
}
